import { motion } from "motion/react";
import ImageWithFallback from "../ui/ImageWithFallback";

export default function AboutSection({
                                         kennelName,
                                         primaryColor,
                                         secondaryColor,
                                         onCtaClick,
                                         styles,
                                         imageSrc = "/assets/dogs/Claudia-34.jpg",
                                     }) {
    return (
        <section style={styles.section}>
            <motion.h2
                style={{ ...styles.sectionTitle, color: primaryColor }}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
            >
                Über uns
            </motion.h2>

            <div style={styles.aboutContent}>
                <motion.div
                    style={styles.aboutText}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                >
                    <p>
                        Herzlich willkommen bei unserer Havaneser-Zucht "{kennelName}"! Mit viel Liebe und Hingabe züchten wir
                        gesunde und ausgeglichene Havaneser-Welpen, die in Familien ein liebevolles Zuhause finden.
                    </p>

                    <p>
                        Unsere Zuchthündin Kira bildet die Grundlage unserer Zucht, und wir freuen uns, dass in Zukunft
                        auch Sherry und Amelie unser Zuchtprogramm bereichern werden, sobald sie die Zuchttauglichkeitsprüfung
                        absolviert haben.
                    </p>

                    <p>
                        Alle unsere Hunde leben als vollwertige Familienmitglieder bei uns. Wir legen größten Wert
                        auf eine artgerechte Haltung und optimale Sozialisierung unserer Welpen vom ersten Lebenstag an.
                    </p>

                    <p>
                        Wir bilden uns regelmäßig auf Züchterseminaren weiter, um stets auf dem neuesten Stand zu bleiben
                        und unseren Hunden die bestmögliche Zucht- und Aufzuchtumgebung zu bieten.
                    </p>

                    <motion.button
                        style={{ ...styles.button, backgroundColor: primaryColor }}
                        whileHover={{ scale: 1.05, backgroundColor: secondaryColor }}
                        whileTap={{ scale: 0.95 }}
                        onClick={onCtaClick}
                    >
                        Lernen Sie uns kennen
                    </motion.button>
                </motion.div>

                <motion.div
                    style={styles.aboutImage}
                    initial={{ opacity: 0, x: 20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                    viewport={{ once: true }}
                >
                    <ImageWithFallback src={imageSrc} alt="Havaneser-Zucht" style={styles.image} />
                </motion.div>
            </div>
        </section>
    );
}
